module.exports = __webpack_public_path__ + "static/img/fail-link.705488c8.png";